import apiService from "../../../../../../service/Api";

export interface MemoryBookApiItem {
  id: number;
  name_of_deceased: string;
  total_comments: number;
  approved_comments: number;
  stream?: {
    id: number;
    title: string;
  };
}

export interface MemoryBooksApiResponse {
  results: MemoryBookApiItem[];
  count?: number;
  next?: string | null;
  previous?: string | null;
}

export interface MinimalUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  profile_picture_url: string | null;
}

export interface MemoryBookAssignmentApiItem {
  id: number;
  stream_id: number;
  assigned_to_id: number;
  assigned_to: MinimalUser;
  assigned_by: MinimalUser;
  physical_comments: number | null;
  remaining_comments: string | null;
  due_date: string;
  done_comments: number | null;
  assigned_at: string;
  updated_at: string;
  stream?: {
    id: number;
    title?: string;
    booking?: {
      deceased?: Array<{
        first_name: string;
        surname: string;
        person_image?: string;
      }>;
    };
  };
}

export interface MemoryBookAssignmentsApiResponse {
  results: MemoryBookAssignmentApiItem[];
  count?: number;
  next?: string | null;
  previous?: string | null;
}

export interface UpdateMemoryBook {
  approved_comments?: number;
}

export const fetchMemoryBooks = () => {
  return apiService.get<MemoryBooksApiResponse>(
    "/api/streams/memory-book/?status=confirmed",
  );
};

export const updateMemoryBook = (id: string, data: UpdateMemoryBook) => {
  return apiService.patch(`/api/streams/memory-book/${id}/`, data);
};


export const fetchAssignedMemoryBooks = (userId: number) => {
  return apiService.get<MemoryBookAssignmentsApiResponse>(
    `/api/streams/memory-book-assignment/?assigned_to=${userId}`,
  );
};

export const updateMemoryBookAssignment = (
  assignmentId: number,
  data: { done_comments?: number },
) => {
  return apiService.patch(
    `/api/streams/memory-book-assignment/${assignmentId}/`,
    data,
  );
};
